export default [
   {
    header: 'Verwaltung',
  },
  {
    title: 'Benutzer',
    route: 'users-list',
    icon: 'UserIcon',
  },
  {
    title: 'Einstellungen',
    route: 'settings',
    icon: 'SettingsIcon',
  },
  {
    title: 'Datenbereinigung',
    route: 'admin-data-cleanup',
    icon: 'Trash2Icon',
    resource: 'AdminArea',
    action: 'manage',
  },
]
